import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./translations/en";
import pt from "./translations/pt";

export const TRANSLATION_LOCAL_STORAGE_KEY = "translation_locale";

i18n
  .use(initReactI18next) 
  .init({
    resources: {
      "en-US": { translation: en },
      // "es-ES": { translation: es },
      "pt-BR": { translation: pt },
      // "fr-FR": { translation: fr },
    },
    lng: localStorage.getItem(TRANSLATION_LOCAL_STORAGE_KEY) || "pt-BR", 
    fallbackLng: "pt-BR",
    interpolation: {
      escapeValue: false 
    }
});

export default i18n;